import React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import './styles.css';

SwiperPage5.propTypes = {
  id: PropTypes.string,
  isActive: PropTypes.bool,
};

SwiperPage5.defaultProps = {
  id: '',
  isActive: false,
};

function SwiperPage5({ id, isActive }) {
  const [animationClass, setAnimationClass] = useState('');
  useEffect(() => {
    if (isActive) {
      setAnimationClass('active'); // Khi active, chạy animation
    } else {
      setAnimationClass(''); // Nếu không active, reset
    }
  }, [isActive]);

  return (
    <div className={`hero-section hero-section-${id} ${animationClass}`}>
      <div class="hero-content">
        <section class="contact-section">
          <div class="slogan">
            <h1>GamePiece Labs</h1>Nâng tầm trải nghiệm Boardgame của bạn
          </div>
          <div class="contact-info">
            {/* <!-- Address Column --> */}
            <div class="address">
              <h3>Địa chỉ</h3>
              <p>Thành phố Hồ Chí Minh, 70000</p>
            </div>
            {/* <!-- Email Column --> */}
            <div class="email">
              <h3>Email</h3>
              <p>(Cập nhật sau)</p>
            </div>
            {/* <!-- Social Column --> */}
            <div class="social">
              <h3>Mạng xã hội</h3>
              <div class="social-item">
                <h4>Fanpage</h4>
                <p>
                  <a href="https://www.facebook.com/GamePieceLabs/" target="_blank" rel="noreferrer">
                    https://www.facebook.com/GamePieceLabs/
                  </a>
                </p>
              </div>
              <div class="social-item">
                <h4>Instagram</h4>
                <p>
                  <a href="https://www.instagram.com/gamepiece.labs/" target="_blank" rel="noreferrer">
                    https://www.instagram.com/gamepiece.labs/
                  </a>
                </p>
              </div>

              <div class="social-item">
                <h4>TikTok</h4>
                <p>
                  <a href="https://www.tiktok.com/@gamepiece_labs" target="_blank" rel="noreferrer">
                    https://www.tiktok.com/@gamepiece_labs
                  </a>
                </p>
              </div>
            </div>
          </div>
        </section>
        <div class="copy-right">
          <p>&copy; 2024 GamePiece Labs. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default SwiperPage5;
